import { h, render, Component } from 'preact'; // eslint-disable-line no-unused-vars

export default () => {
  Array.from(document.getElementsByTagName('SocialIconLinked')).forEach(el => {
    el.setAttribute('class', 'icon-wrapper');
    render(
      <svg
        className="connect__icon icon icon__linkedin-circle"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 130 130"
      >
        <circle className="circle" cx="65" cy="65" r="63"/>
        <circle className="circle circle__inner" cx="65" cy="65" r="60"/>
        <path
          className="foreground"
          d="M104,67.7c0-11,0-22.1,0-33.1c0-0.5,0-1-0.1-1.4c-0.6-2.6-2.9-4.5-5.6-4.5c-22.2,0-44.4,0-66.6,0 c-0.4,0-0.7,0-1.1,0.1c-2.9,0.6-4.6,2.8-4.6,5.7c0,22.1,0,44.2,0,66.3c0,0.3,0,0.6,0.1,0.9c0.2,2.6,2.5,5,5.6,5 c22.2,0,44.5,0,66.7,0c1.7,0,3.1-0.7,4.2-2c1-1.1,1.4-2.4,1.4-3.9C104,89.8,104,78.8,104,67.7z"
          transform="translate(0 -2)"
        />

        <path
          className="background"
          d="M67.6,63c0.2-0.3,0.3-0.5,0.5-0.8c1-1.5,2.3-2.7,3.9-3.6c1.9-1.1,4-1.6,6.2-1.6c2.2-0.1,4.4,0.2,6.5,0.9 c2.4,0.8,4.2,2.3,5.5,4.5c1,1.7,1.6,3.6,1.9,5.6c0.2,1.3,0.4,2.5,0.4,3.8c0.1,2.9,0.1,5.8,0.1,8.7c0,4.7,0,9.4,0,14.1 c0,0.2,0,0.3,0,0.6c-0.2,0-0.3,0-0.5,0c-3.6,0-7.2,0-10.7,0c-0.5,0-0.5,0-0.5-0.5c0-6.5,0-13,0-19.4c0-1.7-0.2-3.4-0.8-4.9 c-0.8-1.9-2.2-2.8-4.2-3.1c-1.1-0.1-2.3,0-3.4,0.3c-1.9,0.5-3.1,1.9-3.7,3.7C68.3,72.5,68,73.7,68,75c0,6.5-0.1,13.1-0.1,19.6 c0,0.7,0.1,0.6-0.6,0.6c-3.5,0-7,0-10.5,0c-0.5,0-0.5,0-0.5-0.5c0-12.1,0-24.2,0-36.3c0-0.5,0-0.5,0.5-0.5c3.4,0,6.7,0,10.1,0 c0.5,0,0.5,0,0.5,0.5c0,1.4,0,2.8,0,4.2C67.5,62.7,67.5,62.9,67.6,63C67.5,63,67.6,63,67.6,63z"
          transform="translate(0 -2)"
        />
        <path
          className="background"
          d="M37.5,95.2c0-0.2,0-0.3,0-0.5c0-12.1,0-24.2,0-36.3c0-0.5,0-0.5,0.5-0.5c3.5,0,7,0,10.5,0c0.6,0,0.6,0,0.6,0.6 c0,12.1,0,24.1,0,36.2c0,0.5,0,0.5-0.5,0.5c-3.5,0-7.1,0-10.6,0C37.9,95.2,37.7,95.2,37.5,95.2z"
          transform="translate(0 -2)"
        />
        <path
          className="background"
          d="M43.4,39.4c3.7,0,6.8,3,6.8,6.7c0,3.8-2.9,6.8-6.8,6.8c-3.8,0-6.7-3.1-6.7-6.8C36.6,42.5,39.7,39.3,43.4,39.4z "
          transform="translate(0 -2)"
        />
      </svg>,
      el
    );
  });
};
